export const vehicleTypeFormat = (
  requestString: string,
  vehicleType: number,
): string => `${requestString}${vehicleType === 1 ? '' : `?vt=${vehicleType}`}`;
